module.exports = __webpack_public_path__ + "static/media/Immunization-Music-Video.83946da2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Immunization-Music-Video.jpg
// module id = 174
// module chunks = 0